const c = (t) => t == null ? void 0 : t.replace(/^\/+|\/+$/g, ""), a = (t, e) => c(t) === c(e), l = (t, e) => {
  if (!e) return null;
  const n = (i, u = []) => i.reduce((s, r, f) => {
    if (s)
      return s;
    const o = [...u, f];
    return r.url === e ? o : r.nestedLinks ? n(r.nestedLinks, o) : null;
  }, null);
  return n(t);
}, L = (t) => t.join("-"), p = (t) => t.split("-"), v = (t) => {
  const e = p(t);
  return e.pop(), e.join("-");
}, h = (t = [], e) => !(t != null && t.length) || !e ? !1 : t.some((n) => a(n.url, e) ? !0 : n.nestedLinks ? h(n.nestedLinks, e) : !1), d = (t, e) => e === "" ? t.length > 0 && !t.includes("s-") : t === e || t.startsWith(`${e}-`), A = (t, e) => {
  for (const n of Array.from(t))
    d(n, e) && t.delete(n);
};
export {
  l as findActivePath,
  h as hasActiveDescendant,
  a as isCurrentPage,
  v as parentOf,
  L as pathToId,
  A as removeBranch,
  c as removeLeadingAndTrailingSlashes,
  p as splitPath
};
